import { render, staticRenderFns } from "./Congress.vue?vue&type=template&id=cc96f1f6&scoped=true&"
import script from "./Congress.vue?vue&type=script&lang=js&"
export * from "./Congress.vue?vue&type=script&lang=js&"
import style0 from "./Congress.vue?vue&type=style&index=0&id=cc96f1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc96f1f6",
  null
  
)

export default component.exports